import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { SecurityMfa } from "./SecurityMfa";
import { Button } from "./ui/button";
import { ShieldAlert, LogOut, ArrowRight } from "lucide-react";

export default function MfaEnrollGate() {
  const { refresh, logout } = useAuth();
  const [enabled, setEnabled] = useState(false);
  return (
    <div className="min-h-screen bg-background text-foreground dark flex items-center justify-center p-6" data-testid="mfa-enroll-gate">
      <div className="w-full max-w-2xl space-y-6">
        <div className="flex items-start gap-3">
          <div className="h-11 w-11 rounded-sm bg-amber-500/15 text-amber-400 flex items-center justify-center shrink-0">
            <ShieldAlert className="h-6 w-6" />
          </div>
          <div>
            <h1 className="font-display text-2xl font-bold tracking-tight">Two-factor authentication is required</h1>
            <p className="text-sm text-muted-foreground mt-1">
              Your organisation requires every user to protect their account with an authenticator app
              (Google Authenticator, Microsoft Authenticator, 1Password). Set it up below to continue —
              it takes about a minute.
            </p>
          </div>
        </div>
        <SecurityMfa onStatusChange={(st) => setEnabled(!!st?.enabled)} />
        <div className="flex items-center justify-between">
          <Button variant="ghost" size="sm" onClick={logout} data-testid="mfa-gate-signout">
            <LogOut className="h-3.5 w-3.5 mr-1.5" /> Sign out
          </Button>
          <Button variant={enabled ? "primary" : "outline"} size="sm" onClick={refresh} disabled={!enabled} data-testid="mfa-gate-continue">
            Continue to dashboard <ArrowRight className="h-3.5 w-3.5 ml-1.5" />
          </Button>
        </div>
      </div>
    </div>
  );
}
